import { useCallback, useMemo, useRef, useState } from 'react';
import type { IColumnCustomizationEntry } from '@/creditflowresearch/application/BondScreener/Sidebar/useColumnsCustomization';

interface IUseHideDeselectedReturn {
  hideDeselected: boolean,
  getHideDeselected: () => boolean,
  toggleHideDeselected: () => void,
  visibleCollection: IColumnCustomizationEntry[],
}

const useHideDeselected = (draftColumns: IColumnCustomizationEntry[]): IUseHideDeselectedReturn => {
  const [hideDeselected, setHideDeselected] = useState(false);

  const hideDeselectedRef = useRef(hideDeselected);
  hideDeselectedRef.current = hideDeselected;

  const getHideDeselected = useCallback((): boolean => hideDeselectedRef.current, []);
  const toggleHideDeselected = useCallback((): void => setHideDeselected((v) => !v), []);

  const visibleCollection = useMemo(
    () => hideDeselected ? draftColumns.filter((col) => col.isVisible) : draftColumns,
    [hideDeselected, draftColumns],
  );

  return {
    hideDeselected,
    getHideDeselected,
    toggleHideDeselected,
    visibleCollection,
  };
};

export default useHideDeselected;
